export const MODAL_HEADING_ID = 'filter-dialog-heading';